import {
  formatDate,
  formatDateTime,
  formatDateWithAMPM,
} from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

export let colData = [
  {
    name: "PO_REPORT",
    columns: [
      {
        name: "Company Code",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.companyCode}</span>
          </>
        ),
        selector: (row) => row.companyCode || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Grp",
      //   selector: (row) => row.purchasingGroup || "--",
      //   sortable: true,
      //   width: "120px",
      // },
      {
        name: "Doc Type",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">
              {row.purchasingDocumentType}
            </span>
          </>
        ),
        selector: (row) => row.purchasingDocumentType || "--",
        sortable: true,
        width: "130px",
      },
      {
        name: "PO Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        cell: (row) => (
          <>
            <span>{formatDate(row.purchasingDocumentDate)}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor",
        selector: (row) => row.vendorCode || "--",
        cell: (row) => (
          <div>
            <p className="m-0 p-0">{row.vendorCode}</p>
            <p className="m-0 p-0">{row.vendorName}</p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },

      {
        name: "Satus",
        selector: (row) => row.statusHeader || "--",
        cell: (row) => (
          <>
            <TableStatusField status={row.statusHeader} />
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Quantity ",
        selector: (row) => row.purchaseQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Plant",
        selector: (row) => row.plant || "--",
        width: "100px",
      },
    ],
  },
  {
    name: "PR_REPORT",
    columns: [
      {
        name: "Company Code",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.companyCode}</span>
          </>
        ),
        selector: (row) => row.companyCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Org",
        selector: (row) => row.purchasingOrg || "--",
        sortable: true,
        width: "120px",
      },
      {
        name: "Pur Category",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
          </>
        ),
        selector: (row) => row.purchaseCategory || "--",
        sortable: true,
        width: "130px",
      },
      {
        name: "PR Nr",
        selector: (row) => row.purchaseReqDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.purchaseReqDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Satus",
        selector: (row) => row.prStatusHeader || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.prStatusHeader}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Item Nr",
        selector: (row) => row.purchasingReqDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Quantity ",
        selector: (row) => row.purchaseQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "ASN_REPORT",
    columns: [
      {
        name: "ASN Nr",
        selector: (row) => row.asnNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.asnNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Status",
        selector: (row) => row.asnStatusHeader || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "ASN Item Nr",
        selector: (row) => row.asnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " ASN Qty ",
        selector: (row) => row.asnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "INVOICE_REPORT",
    columns: [
      {
        name: "INV Nr",
        selector: (row) => row.invoiceNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "INV Date",
        selector: (row) => row.invDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.invoiceStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "INV Item Nr",
        selector: (row) => row.invoiceItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " INV Qty ",
        selector: (row) => row.invoiceQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "GRN_REPORT",
    columns: [
      {
        name: "GRN Nr",
        selector: (row) => row.grnNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.grnNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "GRN Date",
        selector: (row) => row.grnDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.grnStatusHeader || "--",
        cell: (row) => <TableStatusField status={row.grnStatusHeader} />,
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor",
        selector: (row) => row.vendorCode || "--",
        cell: (row) => (
          <div>
            <p className="m-0 p-0">{row.vendorCode}</p>
            <p className="m-0 p-0">{row.vendorName}</p>
          </div>
        ),
        width: "160px",
      },

      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },

      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "GRN Item Nr",
        selector: (row) => row.grnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " GRN Qty ",
        selector: (row) => row.grnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },

      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Plant",
        selector: (row) => row.plant || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
      {
        name: "Mov Type",
        selector: (row) => row.movementType || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "QC_REPORT",
    columns: [
      {
        name: "Quality Check Nr",
        id: "documentNumber",
        dropDown: true,
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <button className="btnInfo">{row.documentNumber} </button>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "GRN Date/Time",
        selector: (row) => formatDateTime(row.createdAt) || "--",
        cell: (row) => (
          <div>
            <span>{formatDateWithAMPM(row.createdAt)}</span>
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Vendor",
        selector: (row) => row.vendorCode,
        sortable: true,
        width: "120px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
            <p className="m-0 p-0">{row.vendorName} </p>
          </div>
        ),
      },
      // {
      //   name: "GRN Value",
      //   selector: (row) => row.sumOfGrn || "--",
      //   cell: (row) => (
      //     <span className="numberFormate  p-0 pt-1 fw-bold m-1">
      //       {currencyFormat(Number(row.sumOfGrn).toFixed(2))}
      //       <span className="m-1 p-0 pt-1 fw-bold text-primary ms-1">
      //         {row.currencyCode}{" "}
      //       </span>
      //       {/* <p className="m-0 p-0">{row.currency} </p> */}
      //     </span>
      //   ),
      //   sortable: true,
      //   width: "150px",
      // },

      {
        name: "PO Number",
        selector: (row) => row.purchasingDocumentNr,
        cell: (row) => (
          <>
            {row.purchasingDocumentNr && (
              <button className="btnInfo">{row.purchasingDocumentNr} </button>
            )}
            {!row.purchasingDocumentNr && (
              <>
                {" "}
                <p>--</p>{" "}
              </>
            )}
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Date/Time",
        selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
        cell: (row) => (
          <div>
            <p>{formatDateWithAMPM(row?.purchasingDocumentDate)}</p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },

      {
        name: "Invoice",
        selector: (row) =>
          formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
        cell: (row) => (
          <div>
            <p className="p-0 m-0 fw-medium">{row?.vendorInvoiceNo}</p>
            <p className="p-0 m-0">{row?.vendorInvoiceDate}</p>
          </div>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Total Invoice Amount",
        selector: (row) =>
          formatDateWithAMPM(row?.vendorTotalInvoiceValue) || "--",
        cell: (row) => (
          <div>
            <p className="p-0 m-0 fw-medium">{row?.vendorTotalInvoiceValue}</p>
          </div>
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "E-Way Bill",
        selector: (row) =>
          formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
        cell: (row) => (
          <div>
            <p className="p-0 m-0 fw-medium">{row?.ewayBillNumber}</p>
            <p className="p-0 m-0">{row?.ewayBillExpiryDate}</p>
          </div>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Delivery Note",
        selector: (row) => row.grnRemark || "--",
        sortable: true,
        width: "140px",
      },
      {
        name: "Quality CK Cancel",
        selector: (row) => row.qualityCheckStatus,
        sortable: true,
        width: "150px",
        cell: (row) => (
          <div>
            {row.grnStatusHeader === "Cancelled" ? (
              <p className="m-0 p-0 pt-1 text-danger fw-bold">
                {row.qualityCheckStatus}{" "}
              </p>
            ) : (
              <p className="m-0 p-0 pt-1 text-success fw-bold">
                {row.qualityCheckStatus}{" "}
              </p>
            )}
            <p className="m-0 p-0 text-danger">{row.cancellationRemark} </p>
          </div>
        ),
      },
    ],
  },
  //--- For ERF Rent Item Wise Report
  {
    name: "ERF_RENT_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id: "orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        id: "erfType",
        dropDown: true,
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
            {/* <p className="m-0 p-0">{row.erfTypeDescription}</p> */}
          </div>
        ),
        width: "180px",
      },
      {
        name: "Privilage Case",
        id: "privilegeCase",
        dropDown: true,
        selector: (row) => row.privilegeCase || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.privilegeCase} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Contract Start Date",
        selector: (row) => row.erfStartDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.erfStartDate}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Contract End Date",
        selector: (row) => row.erfEndDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.erfEndDate}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },
  //--- For ERF and Extension Combined Report
  {
    name: "ALL_ERF_EXT_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.sourceType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.sourceType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Patient No",
        id:"mobileNr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        id:"caregiverMobileNr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        id: "deliveryState",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Created At",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {row.createdAt}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id: "orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        id: "orderType",
        selector: (row) => row.orderType || "--",
        cell: (row) => (
          <span className="fw-medium">
              <p className="fw-medium">{row.orderType}</p>
            </span>
        ),
        width: "180px",
      },
      {
        name: "Sale Point",
        id:"salePoint",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "ERF Type",
        id:"erfType",
        selector: (row) => row.erfType,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.erfType}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name:  "Cost Center",
         id: "costCenter",   
        selector: (row) => row.costCenter,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.costCenter}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Product Cat",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name:"Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name:  "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name:  "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Quantity",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name:"Godown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name:  "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
       {
        name:  "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
       {
        name:  "Tax",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.taxPercentage}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
       {
        name:  "Amount",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.grossValue}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name:  "Tax Amount",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.taxAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Item Type",
        selector: (row) => row.itemType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.itemType}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Cartage",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cartage}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "125px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "ERF/ EXT No",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {row.documentNumber ? (
              <span className="bg-table-status bg-table-new-status">
                {row.documentNumber}
              </span>
            ) : (
              "-"
            )}
          </div>
        ),
        sortable: true,
        width: "250px",
      },
       {
        name: "Contract Start Date",
        selector: (row) => row.erfStartDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.erfStartDate}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Contract End Date",
        selector: (row) => row.erfEndDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.erfEndDate}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Credit Note Status",
        selector: (row) => row?.creditNoteStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.creditNoteStatus || "-"}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Is Product Returned",
        selector: (row) => row?.isProductReturned, 
        cell: (row) => {
          return (
            <div>
              <p className="fw-medium">{row?.isProductReturned}</p>
            </div>
          );
        },
        width: "180px",
        sortable: true,
      },
      {
        name: "Item Early Closure Date",
        selector: (row) => row.itemEarlyClosureDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.itemEarlyClosureDate}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Item Credit Note Date",
        selector: (row) => row.itemCreditNoteDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.itemCreditNoteDate}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      // {
      //   name: "Early closure Date",
      //   selector: (row) => row.earlyClosureDate,
      //   cell: (row) => (
      //     <div>
      //       <p className="fw-medium">{row.earlyClosureDate}</p>
      //     </div>
      //   ),
      //   width: "200px",
      //   sortable: true,
      // },
      //  {
      //   name: "Credit Note Date",
      //   selector: (row) => row.creditNoteDate,
      //   cell: (row) => (
      //     <div>
      //       <span className="fw-medium">{row.creditNoteDate}</span>
      //     </div>
      //   ),
      //   width: "180px",
      //   sortable: true,
      // },
       {
        name: "Total Credit Note",
        selector: (row) => row.totalCreditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.totalCreditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
       {
        name: "Total Refund Amount",
        selector: (row) => row.returnedAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.returnedAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ]
  },

  //--- For ERF Sale Item Wise Report
  {
    name: "ERF_SALE_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id:"orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
         id:"erfType",
         dropDown:true,
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Privilage Case",
         id:"privilegeCase",
         dropDown:true,
        selector: (row) => row.privilegeCase || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.privilegeCase} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },

  //--- For ERF Service Item Wise Report
  {
    name: "ERF_SERVICE_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id:"orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        id:"erfType",
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Privilage Case",
        id: "privilegeCase",
        dropDown: false,
        selector: (row) => row.privilegeCase || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.privilegeCase} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },

  //--- For ERF Nursing Item Wise Report
  {
    name: "ERF_NURSER_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id:"orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        id:"erfType",
        dropDown:true,
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Privilage Case",
        id: "privilegeCase",
        dropDown: true,
        selector: (row) => row.privilegeCase || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.privilegeCase} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },

  //--- For ERF Sale&Rent Sale Item Wise Report
  {
    name: "ERF_SLRE_ONLY_SALE_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id:"createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id:"orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        id:"erfType",
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Privilage Case",
        id: "privilegeCase",
        dropDown: true,
        selector: (row) => row.privilegeCase || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.privilegeCase} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },

  //--- For ERF Sale&Rent -Rent Item Wise Report
  {
    name: "ERF_SLRE_ONLY_RENT_REPORT",
    columns: [
      {
        name: "Type",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Package",
        selector: (row) => row.orderType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderType}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "Patient Name",
        selector: (row) => row.patientName,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.patientName}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Age",
        selector: (row) => row.age,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.age}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Challenges",
        selector: (row) => row.patientChallenges,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.patientChallenges}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Mobile Nr",
        selector: (row) => row.mobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Caregiver Nr",
        selector: (row) => row.caregiverMobileNr,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.caregiverMobileNr}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery Address",
        selector: (row) => row.deliveryAddress,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryAddress}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Delivery State",
        selector: (row) => row.deliveryState,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryState}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Delivery Pincode",
        selector: (row) => row.deliveryPinCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.deliveryPinCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "Email",
        selector: (row) => row.email,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.email}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Bill Date",
        id: "createdAt",
        selector: (row) => row.createdAt || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              {formatDateWithAMPM(row.createdAt)}
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Date",
        id: "orderDate",
        selector: (row) => row.orderDate || "--",
        cell: (row) => (
          <div>
            <span className="fw-medium">
              <p className="fw-medium">{row.orderDate}</p>
            </span>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Type",
        selector: (row) => row.erfType || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.erfType} />
          </div>
        ),
        width: "180px",
      },
      {
        name: "Sale Bill Number",
        selector: (row) => row.saleInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleBillNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Rent Bill Number",
        selector: (row) => row.rentInvoiceNumber || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.rentInvoiceNumber} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Sale Point",
        selector: (row) => row.salePoint || "--",
        cell: (row) => (
          <div>
            <p>{row.salePoint}</p>
          </div>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Sale Head",
        selector: (row) => row.saleHead || "--",
        cell: (row) => (
          <div>
            <TableStatusField status={row.saleHead} />
          </div>
        ),
        width: "140px",
      },
      {
        name: "Cost Centre Group",
        selector: (row) => row.costCenter || "--",
        cell: (row) => (
          <div>
            {/* <TableStatusField status={row.costCenter} /> */}
            <p>{row.costCenter}</p>
          </div>
        ),
        width: "180px",
      },
      {
        name: "Cost Centre Sub Group",
        selector: (row) => row.erfCostCenterSubGroup || "--",
        cell: (row) => (
          <div>
            <p>{row.erfCostCenterSubGroup}</p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Product Category",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: (row) => row.materialSubCategory,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialSubCategory}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Brand",
        selector: (row) => row.brand,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.brand}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Name",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "160px",
        sortable: true,
      },
      {
        name: "Qty",
        selector: (row) => row.orderedQuantity,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.orderedQuantity}</p>
            <p className="fw-medium">{row.orderUnitOfMeasure}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "MRP",
        selector: (row) => row.masterMRP,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterMRP}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },
      {
        name: "Rate",
        selector: (row) => row.netValue,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.netValue}</p>
          </div>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material Tax %",
        selector: (row) => row.taxPercentage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxPercentage}</span>
          </div>
        ),
        width: "140px",
        sortable: true,
      },
      {
        name: "Material Gross Val",
        selector: (row) => row.grossValue,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.grossValue}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Tax Amt",
        selector: (row) => row.taxAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.taxAmount}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cartage Amt",
        selector: (row) => row.cartage,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.cartage}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Total Amt",
        selector: (row) => row.netAmount,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.netAmount}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Material Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.materialCode}</span>
          </div>
        ),
        width: "150px",
        sortable: true,
      },

      {
        name: "Sale Party",
        selector: (row) => row.salePoint,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.salePoint}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note",
        selector: (row) => row.creditNote,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNote}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Credit Note Date",
        selector: (row) => row.creditNoteDate,
        cell: (row) => (
          <div>
            <span className="fw-medium">{row.creditNoteDate}</span>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Days",
        selector: (row) => row.days,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.days}</p>
          </div>
        ),
        width: "120px",
        sortable: true,
      },
      {
        name: "ERF Nr",
        id: "documentNumber",
        selector: (row) => row.documentNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Doctor Type",
        selector: (row) => row?.drType,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drType}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Code",
        selector: (row) => row?.drCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.drCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Doctor Name",
        selector: (row) => row?.doctorName,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.doctorName}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GNT",
        selector: (row) => row?.gnt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.gnt}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Godown Name",
        selector: (row) => row?.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row?.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Cheque Date",
        selector: (row) => row.chequeDate,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque Amount",
        selector: (row) => row.chequeAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeAmount}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cheque No",
        selector: (row) => row.chequeNo,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.chequeNo}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Cash Security Amt",
        selector: (row) => row.cashSecurityAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.cashSecurityAmt}</p>
          </div>
        ),
        width: "200px",
        sortable: true,
      },
      {
        name: "Purchase Rate",
        selector: (row) => row.masterUnitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.masterUnitPrice}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Barcode Status",
        selector: (row) => row.barcodeStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcodeStatus}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Amt",
        selector: (row) => row.refundAmt,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmt}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Refund Days",
        selector: (row) => row.refundDays,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundDays}</p>
          </div>
        ),
        width: "150px",
        sortable: true,
      },
      {
        name: "Account Refund Status",
        selector: (row) => row.refundAmtStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.refundAmtStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "PB Status",
        selector: (row) => row.pbStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbStatus}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
      {
        name: "Remarks",
        selector: (row) => row.pbRemarks,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.pbRemarks}</p>
          </div>
        ),
        width: "220px",
        sortable: true,
      },
    ],
  },

  //--- ForIdle Ageing From 0-30 Bucket Report
  {
    name: "MaterilBarcodeListIdle_0To30",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },



  //--- ForIdle Ageing From 31-60 Bucket Report
  {
    name: "MaterilBarcodeListIdle_31To60",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },

  //--- ForIdle Ageing From 61-90 Bucket Report
  {
    name: "MaterilBarcodeListIdle_61To90",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },



  //--- ForIdle Ageing From 91-180 Bucket Report
  {
    name: "MaterilBarcodeListIdle_91To180",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },

  //--- ForIdle Ageing From 181 to 365 Bucket Report
  {
    name: "MaterilBarcodeListIdle_181To365",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },


  //--- ForIdle Ageing From over 365 Bucket Report
  {
    name: "MaterilBarcodeListIdle_Over365",
    columns: [
      {
        name: "Barcode",
        selector: (row) => row.barcode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.barcode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Code",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialCode}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Product Description",
        selector: (row) => row.materialDescription,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialDescription}</p>
          </div>
        ),
        width: "250px",
        sortable: true,
      },
      {
        name: "Product Group",
        selector: (row) => row.materialGroup,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialGroup}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Vendor Rate",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.unitPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },

      {
        name: "MRP",
        selector: (row) => row.mrPrice,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.mrPrice}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "GoDown",
        selector: (row) => row.godown,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.godown}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Status",
        selector: (row) => row.materialStatus,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.materialStatus}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Created On",
        selector: (row) => row.createdOn,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.createdOn}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Monthly ROI Amt",
        selector: (row) => row.monthlyRoiAmount,
        cell: (row) => (
          <div>
            <p className="fw-medium">{row.monthlyRoiAmount}</p>
          </div>
        ),
        width: "180px",
        sortable: true,
      },
    ],
  },


   
 //--- Invoice reports
  {
    name: "ERF_INVOICE_REPORT",
    columns: [
      {
      name: "Invoice Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {/* {formatDateTime(row.createdAt)} */}
            {formatDateWithAMPM(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
         
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "ERF No",
      selector: (row) => row.equipmentRentNr,
      cell: (row) => (
        <button className="btnInfo" >
          {/* Fallback if documentNumber is missing */}
          {row.equipmentRentNr}
        </button>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "ERF Type",
      selector: (row) => row.erfType,
      cell: (row) => (
        <div>
          <span>
            <TableStatusField status={row.erfType} />
          </span>
        </div>
      ),
      sortable: true,
      style: { justifyContent: "left" },
      width: "210px",
    },
 
    {
      name: "ERF For",
      selector: (row) => row.erfForType,
      cell: (row) => (
        // <span className="fw-bold text-primary">{row.erfForType}</span>
        <span
          // className="badge"
          style={{
            color: row.erfForType === "Hospital" ? "blue" : "orange",
            fontWeight: "bold",
          }}
        >
          {row.erfForType}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Patient Details",
      selector: (row) => row.patientName, // MATCHED API KEY
      cell: (row) => (
        <div>
          <p className="fw-bold">{row.patientName}</p>
          <p>{row.contactNumber}</p>
          <p>{row.billingAddress}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Amount",
      selector: (row) => row?.netAmount || 0,
      cell: (row) => (
        <div className="fw fw-bold">
          {`${Number(row?.netAmount || 0).toFixed(2)} INR`}
        </div>
      ),
      right: true,
      width: "130px",
    },
    {
      name: "Sale Point",
      selector: (row) => row.salePoint,
      cell: (row) => (
        <div>
          <p>{row.salePoint}</p>
          <p className="fw fw-bold">{row.createdBy}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Hospital",
      selector: (row) => row.hospital,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.hospital|| "--"}</p>
          <p className="p-0 m-0">{row.hospitalName || ""}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Cost Center",
      selector: (row) => row.costCenter,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.costCenter|| "--"}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "E_Way Bill Nr",
      selector: (row) => row.e_WayBillNo,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.e_WayBillNo|| "--"}</p>
        </div>
      ),
      wrap: true,
      width: "120px",
    },
      {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.local_id} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      cell: (row) => <span>{formatDate(row?.fromDate)} </span>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,
 
      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,
 
      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,
 
      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,
 
      sortable: true,
      width: "120px",
    },
   
    ],
  },
 

  {
    name: "3_WAY_MATCHING",
    columns: [
      {
        name: "PO Nr",
        id: "purchasingDocumentNr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },

      {
        name: "Vendor",
        id: "vendorCode",
        selector: (row) => row.vendorCode,
        sortable: true,
        width: "150px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
            <p className="m-0 p-0">{row.vendorName} </p>
          </div>
        ),
      },

      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr,
        cell: (row) => (
          <span className="bg-table-status bg-table-new-status w-50">
            {" "}
            {row.purchasingDocumentItemNr}
          </span>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Material",
        selector: (row) => row.materialCode,
        sortable: true,
        width: "200px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        ),
      },
      {
        name: "Qty",
        selector: (row) => row.GoodsMovement[0]?.purchaseQuantity || 0,
        sortable: true,
        width: "100px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">
              {row.GoodsMovement[0]?.purchaseQuantity}{" "}
            </p>
            <p className="m-0 p-0">{row.orderUnitOfMeasure} </p>
          </div>
        ),
      },
      {
        name: "Unit Price",
        selector: (row) => row.orderPriceUnit,
        sortable: true,
        width: "120px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.orderPriceUnit} </p>
            <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
          </div>
        ),
      },

      {
        name: "Item Value",
        selector: (row) => row.netValue,
        sortable: true,
        width: "120px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.netValue} </p>
            <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
          </div>
        ),
      },
      {
        name: "GRN Qty",
        selector: (row) => row.grnQuantity || "--",
        cell: (row) => (
          <span className="fw-bold text-primary">
            {row.grnQuantity || "--"}
          </span>
        ),
        width: "130px",
      },
      {
        name: "GRN Total",
        selector: (row) => row.netValue || "--",
        cell: (row) => (
          <span className="fw-bold text-primary">{row.netValue || "--"}</span>
        ),
        width: "100px",
      },
      {
        name: "GRN Qty (Bal)",
        selector: (row) => row.grnBalancePurchaseQuantity ?? "--",
        cell: (row) => (
          <span className="fw-bold text-primary">
            {row.grnBalancePurchaseQuantity ?? "--"}
          </span>
        ),
        width: "120px",
      },

      {
        name: "INV Qty",
        selector: (row) => row.invoiceQuantity || "--",
        cell: (row) => (
          <span className="fw-bold text-success">
            {row.invoiceQuantity || "--"}
          </span>
        ),
        width: "100px",
      },
      {
        name: "INV Total",
        selector: (row) => row.netValue || "--",
        cell: (row) => (
          <span className="fw-bold text-success">{row.netValue || "--"}</span>
        ),
        width: "100px",
      },

      {
        name: "INV Tax",
        selector: (row) => row.InvoiceRegister[0]?.invItemTaxValue || 0,
        cell: (row) => (
          <span className="fw-bold text-success">
            {row.InvoiceRegister[0]?.invItemTaxValue || "--"}
          </span>
        ),
        width: "100px",
      },
      {
        name: "INV Gross",
        selector: (row) => row.invItemTotalValue || "--",
        cell: (row) => (
          <span className="fw-bold text-success">
            {row.invItemTotalValue || "--"}
          </span>
        ),
        width: "100px",
      },
      {
        name: "INV Qty (Bal)",
        selector: (row) => row.invBalancePurchaseQuantity ?? "--",
        cell: (row) => (
          <span className="fw-bold text-success">
            {row.invBalancePurchaseQuantity ?? "--"}
          </span>
        ),
        width: "130px",
      },
      // {
      //   name: "Status",
      //   selector: (row) => row.statusItem,
      //   cell: (row) => (
      //     <>
      //       <TableStatusField status={row.statusItem} />
      //     </>
      //   ),
      //   sortable: true,
      //   width: "160px",
      // },
    ],
  },
];
